module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-00.2@2x.66f5d585.jpg";